import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import useAuthStore from '../stores/authStore';
import { LoadingSpinner } from './ui';

// Auth check from Cognito ONLY — never an API call. If the API is down,
// users can still open the app (shared-docs/frontend-architecture.md).
export default function PrivateRoute() {
  const [authState, setAuthState] = useState('loading');
  const setAuth = useAuthStore((s) => s.setAuth);

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        setAuth(user);
        setAuthState('authenticated');
      })
      .catch(() => setAuthState('unauthenticated'));
  }, [setAuth]);

  if (authState === 'loading') return <LoadingSpinner size="lg" className="min-h-screen" />;
  if (authState === 'unauthenticated') return <Navigate to="/login" replace />;
  return <Outlet />;
}
